import { Container } from "../../UI/container/Container";
import { Grid, LoadingOverlay } from "@mantine/core";
import { Fragment, useState } from "react";
import { useSpecialistList } from "../../../hooks/react-query/useSpecialistList";
import useAsyncEffect from "use-async-effect";
import { MyButton } from "../../UI/my-button/MyButton";
import { IconChevronRight } from "@tabler/icons";
import { usePaginationStore } from "../../config/store/usePaginationStore";
import { useColors } from "../../../hooks/colors/useColors";
import { useTranslation } from "next-i18next";
import { BlogCard } from "../homepage/blog/BlogCard";
import { useRouter } from "next/router";
import { Footer } from "../homepage/footer/Footer";
import {
  UsefulArticleData,
  useUsefulArticleList,
} from "../../../hooks/react-query/useUsefulArticlesList";
import { UsefulArticleCard } from "./useful-article-card";

type InputProps = {
  prefetchedPosts?: UsefulArticleData[];
};

export function ArticleList({ prefetchedPosts }: InputProps) {
  const { articles } = useUsefulArticleList();
  const { specialists } = useSpecialistList();
  const { colors } = useColors();
  const { i18n } = useTranslation("common");
  const [allUsefulArticles, setAllUsefulArticles] =
    useState<UsefulArticleData[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const { setAfter, setHasNextPage, after } = usePaginationStore(
    (state) => state
  );
  const router = useRouter();

  return (
    <Fragment>
      <Container noHeight>
        <LoadingOverlay visible={loading} className="!fixed !top-0" />
        <Grid>
          {
            <Fragment>
              {specialists &&
                articles &&
                articles.length > 0 &&
                articles.map((post: UsefulArticleData) => {
                  return <UsefulArticleCard key={post.urlSlug} data={post} />;
                })}
            </Fragment>
          }
        </Grid>
        {/*{typeof allUsefulArticles !== "undefined" &&*/}
        {/*  specialists &&*/}
        {/*  allUsefulArticles.data &&*/}
        {/*  allUsefulArticles.data.posts.pageInfo.hasNextPage &&*/}
        {/*  allUsefulArticles.data.posts.pageInfo.endCursor &&*/}
        {/*  typeof prefetchedPosts === "undefined" && (*/}
        {/*    <div className="flex items-center justify-center my-8">*/}
        {/*      <MyButton*/}
        {/*        loading={loading}*/}
        {/*        onClick={() => {*/}
        {/*          setHasNextPage(true);*/}
        {/*          setAfter(*/}
        {/*            allUsefulArticles.data.posts.pageInfo.endCursor?.toString()*/}
        {/*          );*/}
        {/*        }}*/}
        {/*        title={*/}
        {/*          <div className="flex items-center">*/}
        {/*            <span>{i18n.t("load-more")}</span>*/}
        {/*            <IconChevronRight />*/}
        {/*          </div>*/}
        {/*        }*/}
        {/*        color={colors.primary}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*  )}*/}
      </Container>
      <Footer
        isVisible={
          typeof allUsefulArticles !== "undefined" ||
          typeof prefetchedPosts !== "undefined"
        }
      />
    </Fragment>
  );
}
